// UI Constants for Shift Management

export const SHIFT_LABELS = {
  // Page titles and headers
  UPDATE_SHIFT_PAGE_TITLE: 'Shift Management',
  
  // Modal titles and descriptions
  SHIFT_ASSIGNMENT_MODAL_TITLE: 'Update Shift Assignment',
  
  // Form labels
  SHIFT_CATEGORY_LABEL: 'Shift Category',
  SHIFT_NAME_LABEL: 'Shift Name',
  SHIFT_CATEGORY_PLACEHOLDER: 'Select a shift category',
  SHIFT_NAME_PLACEHOLDER: 'Select a shift',
  
  SHIFT_DETAILS_HEADER: 'Shift Details',
  
  // Button labels
  UPDATE_SHIFT_BUTTON: 'Update Shift',
  UPDATE_SHIFTS_BUTTON: 'Update Shifts',
  CLEAR_SELECTION_BUTTON: 'Clear Selection',
  CANCEL_BUTTON: 'Cancel',
  
  // Status and info messages
  NO_EMPLOYEES_FOUND: 'No employees found',
  NO_EMPLOYEES_DESCRIPTION: 'No employees are available for shift assignment. Please contact an administrator.',
  NO_SHIFTS_AVAILABLE: 'No shifts available',
  NO_SHIFTS_DESCRIPTION: 'No active shifts are configured for your company. Please contact an administrator.',
  SELECT_EMPLOYEE_ERROR: 'Please select at least one employee',
  COMPANY_ID_ERROR: 'Company ID not found',
  NO_EMPLOYEES_SELECTED: 'No employees selected',
  
  // Success/Error messages
  SHIFT_UPDATE_SUCCESS: 'Successfully updated shifts for {count} employee(s)',
  SHIFT_UPDATE_ERROR: 'Failed to update shift for employee {id}: {error}',
  SHIFT_UPDATE_GENERAL_ERROR: 'Failed to update shifts. Please try again.',
  LOAD_EMPLOYEES_ERROR: 'Failed to load employees',
  LOAD_SHIFTS_ERROR: 'Failed to load shifts',
  UNKNOWN_ERROR: 'Unknown error occurred',
  
  // Warning messages
  IMPORTANT_WARNING_TITLE: 'Important:',
  IMPORTANT_WARNING_MESSAGE: 'This action will update the shift assignment for all selected employees. Previous shift assignments will be marked as inactive, and the new assignment will be effective from today.',
  
  // Instructions
  
  // Loading states
  UPDATING_TEXT: 'Updating...',
  LOADING_TEXT: 'Loading...',
  
  // Employee status
  EMPLOYEE_STATUS: {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    SUSPENDED: 'Suspended',
    TERMINATED: 'Terminated',
    ON_LEAVE: 'On Leave'
  },
  
  // Shift details
  SHIFT_DETAILS: {
    START_TIME: 'Start Time',
    END_TIME: 'End Time',
    BREAK_HOURS: 'Break Hours',
    VALID_FROM: 'Valid From',
    CATEGORY: 'Category',
    CODE: 'Code',
    HOURS_UNIT: 'hours',
    NOT_SET: 'Not set'
  }
} as const;

export const SHIFT_ACTIONS = {
  SELECT_EMPLOYEE: 'select_employee',
  SELECT_DEPARTMENT: 'select_department',
  CLEAR_SELECTION: 'clear_selection',
  UPDATE_SHIFT: 'update_shift',
  OPEN_MODAL: 'open_modal',
  CLOSE_MODAL: 'close_modal'
} as const;

export const SHIFT_STATUS = {
  LOADING: 'loading',
  IDLE: 'idle',
  UPDATING: 'updating',
  ERROR: 'error',
  SUCCESS: 'success'
} as const;

export const SHIFT_SELECTION_STATE = {
  NONE: 'none',
  PARTIAL: 'partial',
  FULL: 'full'
} as const; 